import Dialog	from "dialog";
import template from "../html/dialog-config-pump-acid.html";
import css		from "../css/dialog-config-pump-acid.css";
import sleep	from "sleep";

class ConfigAcidPumpDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-pump-acid", ConfigAcidPumpDialog);
  }
  constructor() {
    super();

    this.show();
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});

    this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
    this.spinnerTargetMLH.value = this.textboxCurrentMLH.value;        
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }
  buttonClose_click(event) {
    this.close();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.acidPump.id;
    this.textboxDeviceStatus.value = devices.acidPump.status;
    this.textboxCurrentRPM.value = devices.acidPump.rpm;
    this.textboxCurrentMLH.value = devices.acidPump.mlh;
    this.textboxCalibrationStatus.value = devices.acidPump.calibrationStatus;
    this.spinnerSumML.value = Math.round(parseFloat(devices.acidPump.sumML)*10)/10;
  }
  spinnerTargetRPM_change(event) {
    server.rcall("RM_acidpump_setRPM", this.spinnerTargetRPM.value).catch(function(result) {
      alert(result);
    });
  }
  spinnerTargetMLH_change(event) {
    server.rcall("RM_acidpump_setMLH", this.spinnerTargetMLH.value).catch(function(result) {
      alert(result);
    });
  }
  async buttonCalibrate_click(event) {
    try {
      this.iconCalibrate.style.display = "block";
      this.iconCalibrate.style.animationName = "spin";
      this.iconCalibrate.iconname = "view-refresh";
      await server.rcall("RM_acidpump_calibrate", this.spinnerCalibrationRPM.value, this.spinnerCalibrationMLH.value);
      this.iconCalibrate.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.iconCalibrate.iconname = "process-stop";    
    } finally {
      this.iconCalibrate.style.animationName = "";
      await sleep(2000);
      this.iconCalibrate.style.display = "none";
    }
  }
  async buttonClearSum_click(event) {
    try {
      this.iconClearSum.style.display = "block";      
      this.iconClearSum.style.animationName = "spin";
      this.iconClearSum.iconname = "view-refresh";
      await server.rcall("RM_acidpump_clearsum");
      this.iconClearSum.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.iconClearSum.iconname = "process-stop";    
    } finally {
      this.iconClearSum.style.animationName = "";
      await sleep(2000);
      this.iconClearSum.style.display = "none";
    }
  }  
}

ConfigAcidPumpDialog.constructor();

export default ConfigAcidPumpDialog;